var shapesNamingLabel = [

  {shape_id : "newfoundland_and_labrador", admin1: "NEWFOUNDLAND AND LABRADOR", value: "Newfoundland and Labrador"},
  {shape_id : "new_brunswick", admin1: "NEW BRUNSWICK", value: "New Brunswick"},
  {shape_id : "yukon", admin1: "YUKON", value: "Yukon"},
  {shape_id : "british_columbia", admin1: "BRITISH COLUMBIA", value: "British Columbia"},
  {shape_id : "quebec", admin1: "QUEBEC", value: "Quebec"},
  {shape_id : "prince_edward_island", admin1: "PRINCE EDWARD ISLAND", value: "Prince Edward Island"},
  {shape_id : "saskatchewan", admin1: "SASKATCHEWAN", value: "Saskatchewan"},
  {shape_id : "alberta", admin1: "ALBERTA", value: "Alberta"},
  {shape_id : "manitoba", admin1: "MANITOBA", value: "Manitoba"},
  {shape_id : "nova_scotia", admin1: "NOVA SCOTIA", value: "Nova Scotia"},
  {shape_id : "ontario", admin1: "ONTARIO", value: "Ontario"},
  {shape_id : "nunavut", admin1: "NUNAVUT", value: "Nunavut"},
  {shape_id : "northwest_territories", admin1: "NORTHWEST TERRITORIES", value: "Northwest Territories"},
  {shape_id : "allstates_ca", admin1: "allstates", value: "allstates"},

]
export default shapesNamingLabel;



// WEBPACK FOOTER //
// ./src/modules/charts/shapesNamingLabel.js